import React, { useCallback , useState } from "react"
import Spinning from 'app/components/Spinning'


const Confirmation = ({ onConfirm, cancel }) => {
  return <div className="frow flex-1 btn-group btn-confirmable-confirmation">
           <div className="btn btn-secondary flex-1" onClick={ cancel }> No </div>
           <div className="btn btn-success flex-2" onClick={ onConfirm }> Yes </div>
         </div>
}

export default ({ className, children, onConfirm, isSpinning = false, confirmation = 'Are you sure?' }) => {
  const [isConfirming, setIsConfirming] = useState(false)

  const confirm = useCallback(() => {
    if(isSpinning) return
    setIsConfirming(true)
  })

  const cancel = useCallback(() => {
    if(isSpinning) return
    setIsConfirming(false)
  })

  if(isSpinning)
    return <Spinning className="text-xl" />

  return <div className={ clsx('btn-confirmable', { 'btn-confirmable-confirming': isConfirming }) }>
           <div className="text-center mb-1 text-gray-500 btn-confirmable-label"> Really? </div>
           <div className="frow items-center">
             <div className="btn-confirmable-child">
               <button className={ `${className}` } onClick={ confirm }>
                 { children }
               </button>
             </div>
             <Confirmation onConfirm={ onConfirm } cancel={ cancel } />
           </div>
         </div>
}
